<div *ngIf="pages$ | async as pages">
    <ng-container *ngFor="let page of pages">
        <web-pages-drawer-item
            [page]="page"
            [pages]="pages"
            [pageRouterId]="(routerParams$ | async)?.pageId"
            [siteId]="(routerParams$ | async)?.siteId"
            [domains]="domains$ | async"
            [isSaving]="isSaving$ | async"
            [site]="site$ | async"
        ></web-pages-drawer-item>
    </ng-container>
    <button
        *ngIf="isAllPagesLoaded(selectTotal$ | async)"
        (click)="getMorePages()"
        class="btn btn-default btn-sm mt-15"
    >
        {{ "load_more" | translate }}
    </button>
</div>
